export default {
  signInToYourAccount: "Sign in to your account",
  emailAddress: "Email address",
  password: "Password",
  rememberMe: "Remember me",
  forgotYourPassword: "Forgot your password?",
  signIn: "Sign in",
};
